export const SEARCH_CITY = 'SEARCH_CITY'
export const ARRAY_LIST_TO_DROPDOWN_ALGOLIA_CITY = 'ARRAY_LIST_TO_DROPDOWN_ALGOLIA_CITY'
export const IS_LOADING_ALGOLIA_CITY = 'IS_LOADING_ALGOLIA_CITY'
